import { useState, useEffect, useCallback } from 'react';
import { pingExtensions } from '../services/extensionSyncService';

/**
 * Détecte la présence de l'extension Chrome FlowDino.
 *
 * Retourne `null` tant que la détection est en cours : les appelants doivent traiter
 * ce cas à part pour ne pas afficher « extension absente » pendant la vérification.
 */
const useExtensionInstalled = () => {
    const [isInstalled, setIsInstalled] = useState(null);

    const check = useCallback(async () => {
        const installed = await pingExtensions();
        return installed.length > 0;
    }, []);

    useEffect(() => {
        let cancelled = false;

        check().then((installed) => {
            if (!cancelled) setIsInstalled(installed);
        });

        return () => {
            cancelled = true;
        };
    }, [check]);

    // Permet de relancer la détection après une installation faite sans recharger la page.
    const recheck = useCallback(async () => {
        const installed = await check();
        setIsInstalled(installed);
        return installed;
    }, [check]);

    return { isInstalled, recheck };
};

export default useExtensionInstalled;
